import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { clsx } from 'clsx';
function _RotoryTabLight(props, ref) {
    const { className, ...rest } = props;
    const classes = clsx('go-icon', className);
    return _jsx("span", { className: classes, ref: ref, ...rest, children: _jsx("svg", { width: "1em", height: "1em", fill: "none", viewBox: "0 0 24 24", children: _jsx("path", { stroke: "currentColor", strokeLinecap: "round", d: "M7.5 1.5s9 1.2 9 3.6-8.437 1.8-8.437 4.2 8.437 1.8 8.437 4.2-4.5 1.8-4.5 4.2v4.8m0 0-3.375-3m3.375 3 3.375-3", opacity: 0.9 }) }) });
}
const RotoryTabLight = forwardRef(_RotoryTabLight);
export { RotoryTabLight };
